var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18V15H31.5V18H1.5ZM3.225 8.925L1.275 7.8L2.55 5.55H0V3.3H2.55L1.275 1.125L3.225 0L4.5 2.175L5.775 0L7.725 1.125L6.45 3.3H9V5.55H6.45L7.725 7.8L5.775 8.925L4.5 6.675L3.225 8.925ZM15.225 8.925L13.275 7.8L14.55 5.55H12V3.3H14.55L13.275 1.125L15.225 0L16.5 2.175L17.775 0L19.725 1.125L18.45 3.3H21V5.55H18.45L19.725 7.8L17.775 8.925L16.5 6.675L15.225 8.925ZM27.225 8.925L25.275 7.8L26.55 5.55H24V3.3H26.55L25.275 1.125L27.225 0L28.5 2.175L29.775 0L31.725 1.125L30.45 3.3H33V5.55H30.45L31.725 7.8L29.775 8.925L28.5 6.675L27.225 8.925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/ChangePassword.0a74b2171a32e125efad9399078ff5ef.svg";
export { ForwardRef as ReactComponent };